<template>
  <WsMain maxWidth="95%">
    <WsCRUD
      :modelName="modelName"
      :label="label"
      :fields="fields"
      :liveSearching="true"
      :sortBy="sortBy"
      :showFields="showFields"
      :pageMode="true"
      :showExpand="false"
      :inRowBtnRead="true"
      :rowClickRead="true"
      :filterSelects="filterSelects"
      :isMultiSelect="true"
    >
      <template v-slot:customBtns="{item}">
        <WsIconBtn
          tooltip="複製"
          tooltipPosition="top"
          :to="`/factory/${item.id}/copy`"
          class="ml-1 mr-1"
        >mdi-content-copy</WsIconBtn>
        <WsIconBtn
          tooltip="查看訂閱法規清單"
          tooltipPosition="top"
          :to="`/factory/${item.id}/subscribe_act`"
          class="ml-1 mr-1"
        >mdi-gavel</WsIconBtn>
      </template>
    </WsCRUD>
  </WsMain>
</template>
<script>
import model from "@/models/factory";
export default {
  data: () => ({
    modelName: model.modelName,
    label: model.label,
    fields: model.fields,
    showFields: ["name", "industry_categories", "status", "updated_at"],
    liveSearching: true,
    sortBy: "sequence",
    filterSelects: [
      {
        type: "belongsTo",
        label: "",
        textKey: "name",
        modelName: "area",
        placeholder: "篩選地區",
      },
      {
        conditionKeys: [
          {
            fieldName: "area",
            conditionName: "area",
            type: "array",
          },
        ],
        requiredField: "area",
        label: "",
        type: "hasMany",
        textKey: "name",
        modelName: "area_section",
        placeholder: "篩選子地區",
        hasNoSearch: true,
        hasAllSelectBtn: true,
      },
      // {
      //   conditionKeys: [
      //     {
      //       fieldName: "area",
      //       conditionName: "area",
      //       type: "array",
      //     },
      //   ],
      //   requiredField: "area",
      //   type: "multiple-layer-select",
      //   label: "",
      //   textKey: "name",
      //   modelName: "system_subclasses",
      //   getUrl: "system_class",
      //   placeholder: "篩選領域/子領域",
      //   orderBy: "sequence",
      //   orderWay: "asc",
      // },
      {
        conditionKeys: [
          {
            fieldName: "area",
            conditionName: "area",
            type: "array",
          },
        ],
        requiredField: "area",
        type: "hasMany",
        label: "",
        textKey: "name",
        modelName: "industry_category",
        placeholder: "篩選產業類別",
      },
      {
        type: "belongsTo",
        label: "",
        textKey: "name",
        modelName: "parent_factories",
        placeholder: "篩選所屬集團",
        paramName: "factory",
        getText(item) {
          return this.$_CMS_getFactoryName(item);
        },
      },
      {
        type: "switch-tabs",
        label: "",
        textKey: "name",
        modelName: "status",
        defaultValue: "1",
        items: [
          {
            value: "1",
            text: "顯示",
          },
          {
            value: "0",
            text: "隱藏",
          },
        ],
      },
    ],
  }),
};
</script>